import {UNIT_UPGRADES} from "../../configs/unitUpgrade";
import {getFactionConfig} from "../factions/getFactionConfig";

// Варианты улучшения отряда с учетом фракции ЮНИТА (а не его текущего
// владельца - соблазненный Суккубом отряд гномов должен по-прежнему
// улучшаться только в перечисленные гномам типы, см. unit-scoped-faction-abilities):
// фракции с явным перечнем unitTypes в конфиге (например, гномы без кавалерии)
// могут улучшаться только в перечисленные там типы; без перечня доступны все
// варианты из UNIT_UPGRADES
export const getAvailableUnitUpgrades = (unitType, factionId) => {
  const upgrades = UNIT_UPGRADES[unitType] || [];

  const factionUnitTypes = getFactionConfig(factionId)?.unitTypes;
  if (!factionUnitTypes) {
    return upgrades;
  }

  return upgrades.filter((upgrade) => factionUnitTypes.includes(upgrade.toId));
};
